<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("btn.qualityPlan.result") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('btn.qualityPlan.result')}}</span></router-link></li> -->
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityPlan">
              <span>{{$t('tlt.qualityPlan')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityResult">
              <span>{{$t('tlt.qualityData.result')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.planCode")}}</label>
                  <input class="form-control" type="text" v-model.trim="planCodeFilter" />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.sentTime")}}</label>
                  <mmf-datepicker v-model="sentTimeFilter"></mmf-datepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.shift")}}</label>
                  <input class="form-control" type="text" v-model="shiftFilter" />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.qualityData.itemName")}}</label>
                 <dimsearch
                    name="itemName"
                    v-model="itemNameFilter"
                    :entity="qualityItems"
                    bindId="itemNameFilter"
                    bindProp="itemName"
                    submitProp="itemName"
                  ></dimsearch>
                  <!-- <input class="form-control" type="text" v-model="itemNameFilter" /> -->
                </div>

                <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="MMFClearFilter('qualityData')"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('qualityData')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="qualityDataTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="qualityData"
                inline-actions-disabled
                singleChoice
                halfHeight
                disableEdit
                disableDelete
              ></mmf-table>
            </div>
          </div>
        </div>
      </div>
      <div id="qualityResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="qualityResult"
                inline-actions-disabled
                singleChoice
                halfHeight
                disableEdit
                disableDelete
                :statusOrResult="[{qualityResult :'G',color: 'pink'},{qualityResult :'L',color: 'green'}]"
              >
                <div slot="btnList" class="btn-group">
                  <button v-bind:class="'btn btn-outline-primary btn-sm'" v-on:click="display()">
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.qualityData.2dPicture") }}</span>
                  </button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/qualityMgt/pelletizing/QualityData";
import { fields } from "@/model/prd/qualityMgt/pelletizing/QualityData";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";
import dimsearch from "@/components/MMFDimSearch";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityData/getField",
  mutationType: "qualityData/updateField"
});

export default {
  name: "qualityDataList",
  data() {
    return {itemSelect: "",};
  },
  components: { MmfTable, MmfDatepicker,dimsearch},
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.qualityData.rows,
      tableColumns: gridFields,
      entity: state => state.qualityData.entity,
      checkedItems: state => state.qualityData.checkedItems,
      baseModuleUrl: state => state.qualityData.baseModuleUrl,
      qualityItems: state => state.qualityData.itemCode,
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter"]),
    ...mapActions("qualityResult", ["getDetails", "display"]),
    ...mapMutations("qualityResult", ["setRows"]),
    ...mapActions("qualityData", ["jumpToQualityCheck","selectItem"]),
    loadRows() {
      this.statusFilter = "C";
      this.MMFLoadRows("qualityData");
    }
  },

  watch: {
    checkedItems(newIdList) {
      console.log(newIdList);
      if (newIdList.length > 0) {
        let id = newIdList[0];
        this.getDetails(id);
      } else {
        this.setRows([]); // 清空
      }
    }
  },
   mounted() {
    //自动加载页面 this.MMFLoadRows("rawMaterial");
    // this.$store
    //   .dispatch(
    //     "api/get",
    //     {
    //       url: this.$store.state.qualityItem.baseModuleUrl + "/qualityItem/findAll"
    //     },
    //     {
    //       root: true
    //     }
    //   )
    //   .then(data => {
    //     data.push({});
    //     this.$store.commit("qualityData/setItemCode",data) 
    //   })
      this.loadRows();
  }
  
};
</script>
